<template>
  <div id="popUp" :class="{ mobile : isMobile }">
    <a id="exitx" v-show="!isMobile" v-on:click="exit()"><img src="../assets/arrow-01.png"/></a>
    <div id="progress" :style="{ width: progressdata }"></div>
    <a id="exitx" v-show="isMobile" v-on:click="exit()"><img src="../assets/arrow-01.png"/></a>
  </div>
</template>

<script>
import EventBus from "../Event";

export default {
  name: "Popup",
  props: ['track', 'isMobile'],
  data() {
    return {
      meta: null,
      duration: 58,
      currentTime: null,
      checkProgressInterval: null,
      progressdata: 5
    }
  },
  mounted() {
    this.checkProgressInterval = setInterval(this.progress, 1000);
  },
  beforeDestroy() {
    clearInterval(this.checkProgressInterval);
  },
  methods: {
    exit() {
      EventBus.$emit("exitPopUp");
    },
    progress() {
      let currentlyPlaying = document.getElementById('audio' + this.$props.track);
      let progressBar = document.getElementById('progress');
      this.currentTime = currentlyPlaying.currentTime;
      this.progressdata = Math.ceil(this.currentTime/this.duration * 100);
      progressBar.style.width = this.progressdata + "%";
    }
  }
}
</script>

<style>
#popUp {
  position: fixed;
  margin-left:35%;
  top:20%;
  width:25vw;
  height:5vw;
  background-image: url("../assets/tiles-01-01.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 2.5vh;
  text-align: center;
  white-space: normal;
  padding:10px;
  z-index:5;
  color: rgb(148, 148, 148);
}

#popUp.mobile {
  margin-left:8vw;
  top:70%;
  width:80vw;
  height:20vh;
}

#buy a {
  width: 100%;
  height:100%;
  text-align: center;
  align-self: center;
  padding: 10% 20% 0 20%;
  color: #3d6655;
}

#progress {
  position:absolute;
  left:0;
  top:0;
  background-image: url("../assets/tiles-01-01.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width:2%;
  height: 100%;
  filter: saturate(50%) hue-rotate(-100deg) brightness(300%);
}

#exitx {
  position:relative;
  left:55%;
  top:-8.5vw;
  padding:5px; 
  cursor:pointer;
  font-size:10vw;
}

#exitx img {
height:5vh;
width:auto;
animation: playing 5s infinite;
}


</style>